var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block-header',{class:_vm.className,nativeOn:{"click":function($event){return (function (){ return _vm.onHandle(); })($event)}}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }